import React from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import BlockRenderer from "./BlockRenderer";

const MessageRow = observer(({ message }) => {
  if (message.role === "user") {
    return (
      <div className="copilotMsg copilotMsg--user">
        <div className="copilotMsg__userCol">
          <div
            className="copilotMsg__bubble"
            style={message.queued ? { opacity: 0.6 } : undefined}
          >
            {message.text}
          </div>
          {message.queued && (
            <div className="copilotMsg__queuedHint">
              Queued — sending after the current response
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="copilotMsg copilotMsg--assistant">
      <div className="copilotMsg__avatar">
        <SparkleIcon />
      </div>
      <div className="copilotMsg__content">
        {(message.blocks || []).map((block, index) => (
          <BlockRenderer
            key={block.id}
            block={block}
            isStreaming={
              message.streaming && index === message.blocks.length - 1
            }
          />
        ))}
        {message.streaming && !(message.blocks || []).length && (
          <div className="copilotMsg__pending">
            <span className="copilotDot" />
            <span className="copilotDot" />
            <span className="copilotDot" />
          </div>
        )}
      </div>
    </div>
  );
});

export default MessageRow;
